













































































































































































































































































































































































import { ConfirmDeleteOpportunityDraftModal } from '@/components/opportunities/modals';
import { opportunityFormMixin } from '@/shared';
import { Actions } from '@/store';
import { ToastsService } from '@/utils';
import { Department, LevelEntity, NewOpportunityDraft } from '@/models/opportunities';
import mixins from 'vue-typed-mixins';
import moment from 'moment';
export default mixins(opportunityFormMixin).extend({
  name: 'OpportunityDraftEditView',
  components: {
    ConfirmDeleteOpportunityDraftModal,
  },
  data() {
    return {
      isFormChanged: false,
      approversLimit: 2,
      required: false,
    };
  },
  async created() {
    this.loader.isOpportunityCreateRequestSending = true;
    try {
      await this.$store.dispatch(Actions.opportunities.drafts.fetchCurrent, this.$route.params.id);
      this.updateForm();
    } finally {
      this.loader.isOpportunityCreateRequestSending = false;

      const unwatch = this.$watch('form',
        () => {
          this.isFormChanged = true;
          unwatch();
        },
        { deep: true },
      );
    }
  },
  computed: {
    isRequired(): boolean {
      return this.required;
    },
  },
  methods: {
    updateForm() {
      const {
        id,
        level,
        department,
        members,
        createdAt,
        issuer,
        status,
        ...formData
      } = this.$store.state.opportunities.opportunitiesDrafts.current;

      this.form = {
        ...formData,
        departmentId: (department ? (this.departments.find(d => d.name === department) as Department).id : ''),
        levelId: (this.levels.find(l => l.name.toLowerCase() === level.toLowerCase()) as LevelEntity).id,
        startDate: (formData.startDate ? moment(formData.startDate).toDate() : null),
        endDate: (formData.endDate ? moment(formData.endDate).toDate() : null),
      };
    },
    async addOpportunity() {
      this.required = true;
      await this.$nextTick();
      const isFormValid = await this.$validator.validate();

      if (!isFormValid) {
        return;
      }

      const outputTags = this.form.tags.map(t => t.id ? { id: t.id } : { value: t.value });
      const outputApprovers = this.form.approvers.map(a => a.id);
      const newOpportunity = {
        ...this.form,
        tags: outputTags,
        approvers: outputApprovers,
        draftId: this.$route.params.id,
      };

      this.loader.isOpportunityCreateRequestSending = true;
      try {
        const response = await this.$store.dispatch(Actions.opportunities.create, newOpportunity);
        ToastsService.success(this.$t('opportunities.new.form.notifications.create-success') as string);
        this.$router.push({
          name: 'opportunity-details',
          params: {
            id: response.id,
            showAfterCreatingOpportunityModal: 'true',
          },
        });
      } finally {
        this.loader.isOpportunityCreateRequestSending = false;
      }
    },
    async updateDraft() {
      this.required = false;
      await this.$nextTick();

      const isFormValid = await this.$validator.validate();
      if (!isFormValid) {
        return;
      }

      const outputTags = this.form.tags.map(t => t.id ? { id: t.id } : { value: t.value });
      const outputApprovers = this.form.approvers.map(a => a.id);
      const opportunityDraft = {
        id: this.$route.params.id,
        ...this.form,
        tags: outputTags,
        approvers: outputApprovers,
      };

      this.loader.isOpportunityCreateRequestSending = true;
      try {
        await this.$store.dispatch(Actions.opportunities.drafts.edit, opportunityDraft);
        ToastsService.success(this.$t('opportunities.new.form.notifications.edit-draft-success') as string);
        this.$router.push({
          name: 'opportunity-draft-details',
          params: {
            id: this.$route.params.id,
          },
        });
      } finally {
        this.loader.isOpportunityCreateRequestSending = false;
      }
    },
    openDeleteDraftModal() {
      this.$bvModal.show('delete-opportunity-draft-modal');
    },
  },
});
